module.exports = {
  REVERT_DEPLOYMENT: "revertDeployment",
  GROUP_CREATE: "groupCreate",
  GROUP_DELETE: "groupDelete",
  GROUP_EDIT: "groupEdit",
  SERVICE_CREATE: "serviceCreate",
  SERVICE_DELETE: "serviceDelete",
  SERVICE_EDIT: "serviceEdit",
  SERVICE_RESTART: "serviceRestart",
  POD_INSTANCES_KILL: "killPodInstances",
  TASK_KILL: "taskKill"
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ActionKeys.js